import { LeagueDivision, Match, MatchType } from '@/models/match';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatMatchType(type: MatchType) {
  return type === MatchType.LEAGUE ? 'Ligue' : 'Tournoi';
}

/** Conservative upper bound for how long a match stays "live" after kickoff (90 min). */
export const MATCH_LIVE_DURATION_MS = 90 * 60 * 1000;

/** True while now is between match start (inclusive) and start + duration (inclusive). */
export function isMatchLive(
  matchStart: Date,
  now: Date,
  durationMs: number = MATCH_LIVE_DURATION_MS
): boolean {
  const start = matchStart.getTime();
  const t = now.getTime();
  return t >= start && t <= start + durationMs;
}

export function formatMatchDivision(division: LeagueDivision) {
  switch (division) {
    case LeagueDivision.MULTIPLEX:
      return 'Multiplex';
    case LeagueDivision.ADVANCED:
      return 'Advanced';
    case LeagueDivision.MAIN:
      return 'Main';
    case LeagueDivision.INTERMEDIATE:
      return 'Intermediate';
    case LeagueDivision.ENTRY:
      return 'Entry';
    case LeagueDivision.OPEN10:
      return 'Open 10';
    case LeagueDivision.OPEN9:
      return 'Open 9';
    case LeagueDivision.OPEN1_8:
      return 'Open 1-8';
    default:
      return 'Inconnu';
  }
}

export function matchHasStreamLink(match: Match): boolean {
  return Boolean(match.link) || Boolean(match.matchStreamers?.length);
}

export const removeAttrFromObject = <O extends object, A extends keyof O>(
  object: O,
  attr: A
): Omit<O, A> => {
  const newObject = { ...object };

  if (attr in newObject) {
    delete newObject[attr];
  }

  return newObject;
};
